module.exports = {
  sessionId: 0,
  totalRooms: 0,
  totalAdditionals: 0,
  total_selected_payment: null,
  percent_payment: 25,
  startdate: null,
  enddate: null,
  nights: null,
  rooms: [],
  additionals: [],
  contact: {
    salutation: "",
    title: "",
    firstname: "",
    lastname: "",
    email: "",
    telnumber: "",
    street: "",
    zip: "",
    city: "",
    country: "",
    comment: "",
    newsletter: "0",
    gtb: "0",
  },
  meta: {
    browser: null,
    tracking: null,
  },
};
